import React, { useState,useEffect } from "react";
import { Avatar, Modal, Spin } from "antd";
import "../utils/style.css";
import { useQuery } from 'react-query';
import { getNotification } from "../services/notificationApi";
import { Link, useNavigate } from 'react-router-dom';
import lue from "../../../assets/images/lue.png";
import nonLue from "../../../assets/images/nonLue.png";
import avatar2 from "../../../assets/images/users/avatar-user.png";
import { useTranslation } from "react-i18next";
import { EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import bell from "../../../assets/images/bell.svg";
import succes from "../../../assets/images/succes.png";
const AllNotification = () => {
  const { isLoading, isError, error, data: notifications = [] } = useQuery("notifications", getNotification);
  const { t } = useTranslation();
    const [selectedNotification, setSelectedNotification] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);  
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false); 
 const sortedNotifications = notifications.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
const handleOptionsModal = (notification) => {
  setSelectedNotification(notification); 
  setIsModalOpen(true); 
};
  useEffect(() => {
    console.log("Notification sélectionnée mise à jour:", selectedNotification);
    if (selectedNotification) {
      setIsDetailModalOpen(true);
    }
  }, [selectedNotification]);
  const handleCloseDetailModal = () => {
    setIsDetailModalOpen(false); 
  };
 
  return (
    <div>
      {notifications.length === 0 ? (
      <div className="text-center pb-5 mt-2">          
      <div className="w-25 w-sm-50 pt-3 mx-auto">
              <img src={bell} className="img-fluid" alt="user-pic" />
      </div>
      <div className="   alerte">{t("notification.tous")}  </div>
  </div>
      ) : (
        sortedNotifications.map((notification) => {
        const avatarImage = notification?.vehicle?.fileName;
        const imageUrl = avatarImage
          ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
          : avatar2;

        let statusImage = nonLue;
        let statusText = "Non lue";
        if (notification?.status === "Lue") {
          statusImage = lue;
          statusText = "Lue";
        } else if (notification?.status === "Non lue") {
          statusImage = nonLue;
          statusText = "Non lue";
        }else
        if (notification?.status === "success") {
          statusImage = succes;
          statusText = "Affecté";
        }

        return (
          <div
            key={notification.id}
            className="text-reset notification-item d-block dropdown-item position-relative"
          >
            <div className="d-flex">
              <img
                src={imageUrl}
                className="me-3 rounded-circle avatar-xs"
                alt=""
              />
              <div className="flex-grow-1">
                <Link to="#" className="">
                  <div className=" nameNot d-flex justify-content-between">
                    <div>
                      {notification?.vehicle?.brand || t("notification.notVehicle")}
                      ({notification.receiver?.name || t("notification.notDriver")})
                      <img className="imgNot" src={statusImage} alt={statusText} />
                      <span className="statusNot">{statusText}</span>
                    </div>
                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "30px",
                        height: "30px",
                        backgroundColor: "#f5f5f5",
                        borderRadius: "50%",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                        cursor: "pointer"
                      }}
                      onClick={() => handleOptionsModal(notification)}  
                    >
                       <EyeOutlined style={{ color: '#898989', width: '20px' }} />
                    </span>
                  </div>
                </Link>
                <div className=" message">
                  <div className="mb-1">{notification.message || 'No message available'}</div>
                </div>
                <p className="mb-0 fs-11  hour">
                  <span>
                    <i className="mdi mdi-clock-outline"></i>
                    <span style={{ marginLeft: '8px' }}></span>
                    {notification.createdAt ? (
                      (() => {
                        const date = new Date(notification.createdAt);
                        const day = String(date.getDate()).padStart(2, '0');
                        const month = String(date.getMonth() + 1).padStart(2, '0');
                        const year = date.getFullYear();
                        const hours = String(date.getHours()).padStart(2, '0');
                        const minutes = String(date.getMinutes()).padStart(2, '0');
                        return `${day}/${month}/${year} à ${hours}:${minutes}`;
                      })()
                    ) : (
                      'Unknown time'
                    )}
                  </span>
                  {notification.type === 'inspection' && (
                <Link to={`/inspection/detail/${notification.inspectionId}`} style={{ marginLeft: 'end' }}>
                <span className="consultInspeInci" style={{ cursor: 'pointer' }}>
                {t("notification.consultInspection")}
               </span>
            </Link>
              )}
                </p>
                
              </div>
            </div>
          </div>
        );
      }))}
  






  <Modal
  open={isDetailModalOpen}
  onCancel={handleCloseDetailModal}
  footer={null}
  maxWidth={600} // Limite la largeur à 600px maximum
  style={{
    top: '100px',
    right:'250px',                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               
    zIndex: 9999,
  }}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              
 
>
  <div>
    {selectedNotification ? (
      <div>
        <h3>Détails de la notification</h3>
        <p><strong>Titre:</strong> {selectedNotification.title}</p>
        <p><strong>Message:</strong> {selectedNotification.message}</p>
        <p><strong>État:</strong> {selectedNotification.status}</p>
        <p><strong>Type:</strong> {selectedNotification.type}</p>
        <p><strong>Date:</strong> {new Date(selectedNotification.createdAt).toLocaleString()}</p>

        {(() => {
          const avatarImage = selectedNotification?.receiver?.fileName;
          const imageUrlRecep = avatarImage                      
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImage}`
            : avatar2;
          const avatarImageEmet = selectedNotification?.emitter?.fileName;
          const imageUrlEmet = avatarImageEmet
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageEmet}`
            : avatar2;                                                                                      
          const avatarImageVeh = selectedNotification?.receiver?.vehicle?.fileName;
          const imageUrlVehRecp = avatarImageVeh
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageVeh}`
            : avatar2;
          const avatarImageVehEmet = selectedNotification?.emitter?.vehicle?.fileName;                                                               
          const imageUrlVehEmet = avatarImageVehEmet
            ? `${process.env.REACT_APP_API_MEDIA_URL}/print/${avatarImageVehEmet}`
            : avatar2;

          return (
            <div className="">
              {selectedNotification?.receiver && (
                <div>
                  <div><strong>Information du récepteur:</strong></div>
                  <Avatar className="insp-small-avatarVehicle">
                    <img src={imageUrlRecep} alt="" />
                  </Avatar>
                  <table>
                    <tbody>
                      <tr className="title-th">
                        <td>Nom</td>
                        <td style={{ paddingLeft: '50px' }}>Rôle</td>
                        <td style={{ paddingLeft: '50px' }}>Email</td>
                        <td style={{ paddingLeft: '50px' }}>Véhicule affecté</td>
                      </tr>
                      <tr className="title-td">
                        <td>{selectedNotification?.receiver?.name || "-"}</td>
                        <td style={{ paddingLeft: '50px' }}>{selectedNotification?.receiver?.role?.name || "-"}</td>
                        <td style={{ paddingLeft: '50px' }}>{selectedNotification?.receiver?.email || "-"}</td>
                        <td style={{ paddingLeft: '30px' }}>
                          <img src={imageUrlVehRecp} alt="" className="me-3 rounded-circle avatar-xs" />
                          {selectedNotification?.receiver?.vehicle?.brand || "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
              {selectedNotification?.emitter && (
                <div>
                  <div><strong>Information de l'émetteur:</strong></div>
                  <Avatar className="insp-small-avatarVehicle">
                    <img src={imageUrlEmet} alt="" />
                  </Avatar>
                  <table>
                    <tbody>
                      <tr className="title-th">
                        <td>Nom</td>
                        <td style={{ paddingLeft: '50px' }}>Rôle</td>
                        <td style={{ paddingLeft: '50px' }}>Email</td>
                        <td style={{ paddingLeft: '30px' }}>Véhicule affecté</td>
                      </tr>
                      <tr className="title-td">
                        <td>{selectedNotification?.emitter?.name || "-"}</td>
                        <td style={{ paddingLeft: '50px' }}>{selectedNotification?.emitter?.role?.name || "-"}</td>
                        <td style={{ paddingLeft: '50px' }}>{selectedNotification?.emitter?.email || "-"}</td>
                        <td style={{ paddingLeft: '30px' }}>
                          <img src={imageUrlVehEmet} alt="" className="me-3 rounded-circle avatar-xs" />
                          {selectedNotification?.emitter?.vehicle?.brand || "-"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          );
        })()}
      </div>
    ) : (
      <Spin size="large" />
    )}
  </div>
</Modal>







   
    </div>
  );
};

export default AllNotification;
